
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover/territories",
      function () {
        return require("private-next-pages/discover/territories.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discover/territories"])
      });
    }
  